import React, { useState } from "react";
import { motion } from "framer-motion";
import "./verified.scss";
import Joinmodal from "../modals/Joinmodal";
import Registermodal from "../modals/Registermodal";

const Verified = () => {
  const [modals, setModals] = useState({
    join: false,
    register: false,
  });

  const openModal = (name) => setModals((prev) => ({ ...prev, [name]: true }));
  const closeModal = (name) =>
    setModals((prev) => ({ ...prev, [name]: false }));

  const fadeUp = {
    hidden: { opacity: 0, y: 50, filter: "blur(2px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  return (
    <>
      <section className="verified">
        <span className="verifyshade"></span>
        <div className="custom-container">
          <div className="accessparent">
            <img
              src="/assets/verified/mainimg.png"
              alt="mainimg"
              className="mainimg"
            />
            <motion.div
              className="right"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.3 }}
            >
              <span>For Investors</span>
              <h3>Access Verified Company Data</h3>
              <p>
                View structured company profiles with verified share data,
                transparent trading activity, blockchain-verified records, and
                identity-verified investor discussions in one platform.
              </p>
              <button
                onClick={() => {
                  window.location.href = "https://app.traqstock.com";
                }}
              >
                Join as Investor
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="verified published" id="for-companies">
        <span className="publishshade"></span>
        <div className="custom-container">
          <div className="accessparent">
            <motion.div
              className="right"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.3 }}
            >
              <span>For Public Companies</span>
              <h3>Publish Verified Share Data</h3>
              <p>
                Publish verified share data, provide transparent updates to
                investors, and create a trusted record shareholders can
                independently verify.
              </p>
              <button
                onClick={() => {
                  openModal("register");
                }}
              >
                Register Your Company
              </button>
            </motion.div>
            <img
              src="/assets/verified/publishmainimg.png"
              alt="mainimg"
              className="mainimg"
            />
          </div>
        </div>
      </section>

      <Joinmodal show={modals.join} onHide={() => closeModal("join")} />
      <Registermodal
        show={modals.register}
        onHide={() => closeModal("register")}
      />
    </>
  );
};

export default Verified;
